import React, { useEffect, useRef, useState } from "react";
import IMeeting from "../../api/IMeeting";
import useAxios, { UseAxiosProps } from "./useAxios";
import { useUserStore } from "../../stores/useUserStore";
import { toString } from "../../utilities/stringify";
import useOnNewMeeting from "./useOnNewMeeting";

type UseAllMeetingsProps = {
    axiosProps?: UseAxiosProps;
};

const useAllMeetings = (props?: UseAllMeetingsProps) => {
    const user = useUserStore((state) => state.user);
    const [meetings, setMeetings] = useState<IMeeting[]>([]);

    const { loading, error, clearError, get } = useAxios(props?.axiosProps);
    
    // ✅ 新增：isMounted 检查防止内存泄漏
    const isMountedRef = useRef(true);
    
    useEffect(() => {
        return () => {
            isMountedRef.current = false;
        };
    }, []);

    useEffect(() => {
        if (user.refreshToken.length > 0) getMeeting();
    }, [user.refreshToken.length]);

    useOnNewMeeting({ onMeetingChange: () => getMeeting() });

    const getMeeting = async () => {
        let res = await get<IMeeting[]>(`/api/meeting/GetMeetings`);
        // ✅ 仅在组件仍然挂载时才更新状态
        if (!res || !isMountedRef.current) return;
        setMeetings(res);
    };

    return {
        meetings,
        loading,
        error,
        clearError,
    };
};

export default useAllMeetings;
